module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Aurore-meisje-goudfolie-foliedruk-drukwerk-2.bdb2e940.jpg";